"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const HtmlInclude_1 = require("../../common/html-include/HtmlInclude");
const ProductInfo = props => {
    const productInfoVariable = `<script type="text/javascript">var productInfo = ${JSON.stringify(props)}</script>`;
    return (0, jsx_runtime_1.jsx)(HtmlInclude_1.HtmlInclude, { htmlFragment: productInfoVariable });
};
exports.default = ProductInfo;
